import { render, staticRenderFns } from "./appointmentSuc.vue?vue&type=template&id=c9bade20&scoped=true"
import script from "./appointmentSuc.vue?vue&type=script&lang=js"
export * from "./appointmentSuc.vue?vue&type=script&lang=js"
import style0 from "./appointmentSuc.vue?vue&type=style&index=0&id=c9bade20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bade20",
  null
  
)

export default component.exports